import { css } from '@emotion/css';
import { Spacing } from 'src/styles';

export const container = css`
  ${Spacing.p12}
`;
